<template>
    <div>
        <b-row v-if="searchKey">
            <b-col lg="6" xl="4">
                <b-input-group class="w-100 my-2" :prepend="$t('ticket_scan.button')">
                    <b-form-input type="text" v-model="searchText"></b-form-input>
                    <b-input-group-append>
                        <b-btn><span class="fa fa-search"></span></b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-table outlined responsive striped hover
                         show-empty
                         empty-text="No data to show"
                         :items="filterItems"
                         :fields="columns"
                         class="text-center event-table align-middle"
                         :current-page="currentPage"
                         :per-page="perPage"
                         @row-clicked="rowClick">
                    <template v-slot:cell(position)="data">
                        {{(data.index + 1) + ((currentPage-1) * perPage)}}
                    </template>
                   <!-- <template v-slot:cell(date)="data">
                       {{ data.value | moment('DD.MM.YYYY')}}
                   </template> -->
                                        <template v-slot:cell(actions_slot)="data">
                                            <div class="flex-center actions-slot">
                                                <div v-for="(action, key) in actions"
                                                     class="action px-2"
                                                    @click.stop="actionClick(key,data.item)"
                                                    v-b-tooltip.hover :title="$t(action.name)"
                                                    v-if="data.item.ticket_status_id===22 || data.item.role_name || data.item.dob">
                                                    <i v-if="action.icon" :class="action.icon"></i>
                                                    <b-btn v-else :variant="action.variant">{{action.name}}</b-btn>
                                                </div>
                                           </div>
                                       </template> 
                </b-table>
                <b-pagination
                        align="center"
                        :total-rows="filterItems.length"
                        v-model="currentPage"
                        :per-page="perPage">
                </b-pagination>
            </b-col>
            <b-col>
                <div class="text-right print-show w-100">
                    {{$t('eventsTable.page')}} {{currentPage}} {{$t('eventsTable.of')}} {{totalPages}}
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "event-table",
        props: {
            items: {
                type: Array,
                required: true
            },
            fields: {
                type: Array,
                required: true
            },
            actions: {
                type: Object
            },
            position: {
                type: Boolean
            },
            searchKey: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                position_slot: {
                    key: 'position',
                    label:  'No.'
                },
                
                currentPage: 1,
                perPage: 10,
                searchText: ""
            }
        },
        computed: {
            columns(){
                var self = this;
                var fil = this.fields.map(n => {
                    return {
                        label: self.$t(n.labelPath),
                        key: n.key,
                        thClass: n.thClass,
                        tdClass: n.tdClass,
                        formatter: n.formatter,
                    } 
                })
                if (this.actions) {
                    fil.push(this.actions_slot);
                }
                if (this.position) {
                    fil.unshift(this.position_slot);
                }
                return fil
            },
            action(){
                return this.actions
            },
            actions_slot(){
                return {
                    key: 'actions_slot',
                    label:  this.$t('table.users.actions')
                }
            },
            filterItems() {
                if (this.searchKey) {
                    return this.items.filter(item => {
                        return item[this.searchKey].toLowerCase().includes(this.searchText.toLowerCase());
                    });
                } else {
                    return this.items;
                }
            },
            totalPages() {
                return Math.ceil(this.filterItems.length / this.perPage);
            }
        },
        methods: {
            actionClick(actionKey, item) {
                this.$emit('action', actionKey, item)
            },
            rowClick(item, index, event) {
                this.$emit('rowClicked', item.id)
            }
        }
    }
</script>

<style lang="scss">
    .event-table {
        tr {
            &:hover {
                cursor: pointer;
            }
            width: auto;
        }
    }
</style>